// src/components/Header.jsx
import React, { useState } from 'react';
import { FaBars, FaTimes } from 'react-icons/fa'; // Ícones modernos
import { Link } from 'react-router-dom';

const Header = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

    return (
        <header className="bg-purple-800 text-white p-6 shadow-md fixed w-full top-0 z-50">
            <div className="flex items-center justify-between relative">
                {/* Logo ou Nome */}
                <div className="text-3xl font-bold transition-all duration-300 transform hover:scale-105">
                    <Link to="/" className="hover:text-gray-300 transition-colors duration-300">SmartSalesBot</Link>
                </div>

                {/* Menu de Navegação para Desktop */}
                <nav className="hidden md:flex space-x-8">
                    <Link
                        to="/"
                        className="text-xl hover:text-gray-300 transition-all duration-300 rounded-lg py-2 px-4 transform hover:scale-105"
                    >
                        Home
                    </Link>
                    <Link
                        to="/features"
                        className="text-xl hover:text-gray-300 transition-all duration-300 rounded-lg py-2 px-4 transform hover:scale-105"
                    >
                        Funcionalidades
                    </Link>
                    <Link
                        to="/pricing"
                        className="text-xl hover:text-gray-300 transition-all duration-300 rounded-lg py-2 px-4 transform hover:scale-105"
                    >
                        Preços
                    </Link>
                    <Link
                        to="/contact"
                        className="text-xl hover:text-gray-300 transition-all duration-300 rounded-lg py-2 px-4 transform hover:scale-105"
                    >
                        Contato
                    </Link>
                </nav>

                {/* Botão de Menu para Dispositivos Móveis */}
                <button
                    onClick={toggleMenu}
                    className="md:hidden text-3xl hover:text-gray-300 transition-colors duration-300"
                >
                    {isMenuOpen ? <FaTimes /> : <FaBars />} {/* Ícones de menu hamburguer e fechar */}
                </button>
            </div>

            {/* Menu Lateral para Dispositivos Móveis com Animação */}
            <div
                className={`md:hidden absolute top-0 right-0 w-4/5 bg-purple-800 p-6 rounded-lg transform transition-all duration-300 shadow-lg ${isMenuOpen ? 'translate-x-0' : 'translate-x-full'}`}
                style={{ height: '100vh' }} // Ajuste a altura para preencher toda a tela
            >
                <nav>
                    <Link
                        to="/"
                        className="block py-2 text-white hover:bg-purple-700 rounded-lg mb-2 transition-all duration-300"
                        onClick={toggleMenu} // Fechar o menu ao clicar
                    >
                        Home
                    </Link>
                    <Link
                        to="/features"
                        className="block py-2 text-white hover:bg-purple-700 rounded-lg mb-2 transition-all duration-300"
                        onClick={toggleMenu} // Fechar o menu ao clicar
                    >
                        Funcionalidades
                    </Link>
                    <Link
                        to="/pricing"
                        className="block py-2 text-white hover:bg-purple-700 rounded-lg mb-2 transition-all duration-300"
                        onClick={toggleMenu} // Fechar o menu ao clicar
                    >
                        Preços
                    </Link>
                    <Link
                        to="/contact"
                        className="block py-2 text-white hover:bg-purple-700 rounded-lg mb-2 transition-all duration-300"
                        onClick={toggleMenu} // Fechar o menu ao clicar
                    >
                        Contato
                    </Link>
                </nav>
            </div>
        </header>
    );
};

export default Header;
